module.exports = __webpack_public_path__ + "img/20211209-steps-to-build-your-successful-ecommerce-kingdom.aff1684e.jpg";